import { Form, Input, Button, message } from 'antd'
import addAdmin, { addAdminBody } from 'api/admin/addAdmin'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ValidateErrorEntity } from 'rc-field-form/lib/interface'
import React, { useState } from 'react'
import { getAdminsAction } from 'slices/admins'
import handleFormError from 'utils/handleFormError'

interface PropTypes {
	closeDrawer: Function
}

/**
 * Form Component for adding Admins in admin table
 * AddAdminForm sends firstname, lastname, email, mobile, password to backend and hits addAdmin api to creates a new admin
 * @param closeDrawer - function which get triggered when Add Admin drawer get close
 * @returns Creates a new Admin
 */
const AddAdminForm: React.FC<PropTypes> = ({ closeDrawer }) => {
	const [loading, setLoading] = useState<boolean>(false)

	const { currentPage } = useAppSelector(state => state.admin)

	const dispatch = useAppDispatch()

	const onFinish = async (values: addAdminBody) => {
		try {
			setLoading(true)
			// eslint-disable-next-line no-unused-vars
			const response = await addAdmin(values)
			setLoading(false)
			const options = {
				page: currentPage,
				size: 10,
				query: '',
			}
			dispatch(getAdminsAction(options))
			closeDrawer()
			message.success('New Admin Created')
		} catch (error: any) {
			setLoading(false)
		}
	}

	const onFinishFailed = (errorInfo: ValidateErrorEntity) => {
		handleFormError(errorInfo)
	}

	return (
		<Form
			name='addAdmin'
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			layout='vertical'
		>
			<Form.Item
				label='First Name'
				name='firstName'
				rules={[
					{
						required: true,
						message: 'First name is required',
					},
				]}
			>
				<Input />
			</Form.Item>

			<Form.Item
				label='Last Name'
				name='lastName'
				rules={[
					{
						required: true,
						message: 'Last name is required',
					},
				]}
			>
				<Input />
			</Form.Item>

			<Form.Item
				label='Email'
				name='email'
				rules={[
					{
						required: true,
						message: 'Email is required',
					},
					{
						pattern:
							/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
						message: 'Please enter a valid Email',
					},
				]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				label='Mobile Number'
				name='mobile'
				rules={[
					{ required: true, message: 'Mobile no. is Required' },
					{
						pattern: /^(\+?91|0)?[6789]\d{9}$/,
						message: 'Please enter a valid mobile no.',
					},
				]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				label='Password'
				name='password'
				rules={[
					{ required: true, message: 'Password is Required' },
					{
						pattern: /^[a-zA-Z0-9!@#$%^&*]{8,64}$/,
						message: 'Please provide strong password',
					},
				]}
			>
				<Input.Password />
			</Form.Item>

			<Form.Item>
				<Button type='primary' htmlType='submit' block loading={loading}>
					Create Admin
				</Button>
			</Form.Item>
		</Form>
	)
}

export default AddAdminForm
